import { render, staticRenderFns } from "./IntegratedQuery.vue?vue&type=template&id=2a1339d4&scoped=true&"
import script from "./IntegratedQuery.vue?vue&type=script&lang=js&"
export * from "./IntegratedQuery.vue?vue&type=script&lang=js&"
import style0 from "./IntegratedQuery.vue?vue&type=style&index=0&id=2a1339d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1339d4",
  null
  
)

export default component.exports